import { render } from "./UploadSongConfig.vue?vue&type=template&id=0e390ea8"
import script from "./UploadSongConfig.vue?vue&type=script&lang=js"
export * from "./UploadSongConfig.vue?vue&type=script&lang=js"

import "./UploadSongConfig.vue?vue&type=style&index=0&id=0e390ea8&lang=css"
script.render = render

export default script